import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';



function VerifyInvitationReject() {

    const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();


  const {
    data: detailedFamily,
    isLoading: isDetailedLoading,
    isError: isDetailedError,
  } = useQuery({
    queryKey: ['familyDetails'],
    queryFn: async () => {
      const res = await axios.get(
        `${API_URL}/register-family-details-api`,
        { withCredentials: true }
      );
      return res.data;
    },
    staleTime: 0,
    cacheTime: Infinity,
  });


  const [isSubmitting, setIsSubmitting] = useState(false);

const handleReject = async (e) => {
  e.preventDefault();

  if (isSubmitting) return;

  setIsSubmitting(true);

  try {
    const res = await axios.put(
      `${API_URL}/update-invited-rejection-api`,
      {}, // no body
      {
        withCredentials: true,
      }
    );

    if (res.data.success) {
      toast.success("Rejected invite successfully");

      queryClient.invalidateQueries(['checkInvitation']);

      navigate('/login');
    } else {
      toast.error(res.data.message || "Update failed");
    }

  } catch (error) {
    console.error(error);
    toast.error("Something went wrong");
  } finally {
    setIsSubmitting(false);
  }
};


  
return (
  <div className="scrollPageContainer theme-light">
    <div className="main-wrapper">
      {/* start of header */}
      {isSidebarVisible && <Sidebar />}
      <Header toggleSidebar={toggleSidebar} />
      {/* end of header */}

      {/* start of sidebar */}
      <Sidebar show={showSidebar} toggle={toggleSidebar} />
      {/* End of sidebar */}

      {/* start of footerbar */}
      <Footerbar toggleSidebar={toggleSidebar} />
      {/* end of footerbar */}

      <ToastContainer />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row justify-content-center">
          <div className="col-12 col-lg-8 col-xl-7">

  {/* ✅ tighter grid */}
  <div className="row g-3">
    <div className="d-flex justify-content-center align-items-center min-vh-50">
      <div className="card   border-0 text-center p-4 p-md-5 mt-4 rounded-4 w-100">
        
        {/* Warning Icon with pulse animation */}
        <div className="mb-4">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle position-relative"
            style={{
              width: "80px",
              height: "80px",
              backgroundColor: "#fff5f5",
              border: "2px solid #fecaca",
              
            }}
          >
            <div 
              className="position-absolute rounded-circle"
              style={{
                width: "100%",
                height: "100%",
                border: "2px solid #fca5a5",
                 
                opacity: 0.4,
              }}
            />
            <i className="fa fa-exclamation-triangle text-danger" style={{ fontSize: "2.2rem" }}></i>
          </div>
        </div>

        {/* Title */}
        <h3 className="fw-bold text-danger mb-2">Reject Invitation</h3>

        {/* Divider */}
        <hr className="mx-auto my-3" style={{ width: "60px", borderColor: "#fecaca", borderWidth: "2px" }} />

        {/* Message */}
        <p className="text-secondary mt-2 mb-4" style={{ fontSize: "1rem", lineHeight: "1.7" }}>
          Once you reject the invitation, you won't be able to join{" "}
          {detailedFamily && <span className="fw-semibold text-dark">{detailedFamily.family_name}</span>}{" "}
          unless invited again.
        </p>

        {/* Action Buttons */}
        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-2">
          <Link
            to="/verify-invitation-info-update"
            className=" rounded-3 px-4 py-2 fw-medium"
            style={{
              padding: '0.7rem 1.4rem',
              backgroundColor: 'transparent',
              color: '#184A2C',
              border: '1.5px solid #184A2C',
              borderRadius: '40px',
              fontSize: '0.85rem',
              fontWeight: 600,
              textDecoration: 'none',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#184A2C';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#184A2C';
            }}
          >
            No, Keep Invitation
          </Link>

          <button
            onClick={handleReject}
            className="btn rounded-3 px-4 py-2 fw-medium d-inline-flex align-items-center justify-content-center gap-2"
            style={{
              minWidth: "140px",
              background: "linear-gradient(135deg, #dc2626, #b91c1c)",
              border: "none",
              color: "#fff",
              boxShadow: "0 4px 12px rgba(220, 38, 38, 0.3)",
              transition: "all 0.3s ease",
            }}
            disabled={isSubmitting}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(220, 38, 38, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 12px rgba(220, 38, 38, 0.3)";
            }}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                Processing...
              </>
            ) : (
              <>
                <i className="fa fa-times-circle" />
                Yes, I Reject
              </>
            )}
          </button>
        </div>

        {/* Help text */}
        <p className="text-muted small mt-4 mb-0" style={{ fontSize: "0.8rem" }}>
          <i className="fa fa-info-circle me-1" />
          This action cannot be undone
        </p>
      </div>
    </div>
  </div>

  {/* CSS Animations */}
  <style jsx>{`
    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 0.4;
      }
      50% {
        transform: scale(1.1);
        opacity: 0.1;
      }
      100% {
        transform: scale(1);
        opacity: 0.4;
      }
    }
     
    
     
  `}</style>
</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

}

export default VerifyInvitationReject;
